import React from 'react'

const array = [
    "Aşgabat Halkara howa menzili biznes-klasyň ýolagçylarynyň dykgatyna eksklýuziw hyzmaty - Business Lounge hödürleýär.",
    "Business Lounge — içi gelşikli zal, bu ýerde biziň myhmansöýerligimizi duýmak we öz howa gatnawyňa münmek üçin oňaýly garaşmak, umumy garaşma zolagynyň goh-galmagalyndan we hysyrdysyndan gaça durup, rahatlykdan lezzet almak mümkinçiligi berilýär.",
    "Biznes-klasyň ýolagçylarynyň hyzmatyna şular hödürlenilýär:",
    "• terminalyň binasynda aýratyn bellige alyş diregi;",
    "• “fast track” hyzmaty (tizleşdirilen düzgünde we nobatsyz howa gatnawyna bellige alyş, gümrük hem pasport barlagy);",
    "• ýany bilen barmaklyk we rahat garaşma zalynda ýerleşmeklik, bu ýerde ýolagçylara dürli içgiler (sowuk içgiler, çaý, kofe) hödürleniler;",
    "• “şwed stoly” ulgamy boýunça naharlanma, täze ir-iýmişler, desert;",
    "• täze metbugat neşirleri, mugt Wi-Fi, sanly telewideniýe;",
    "• konferens-hyzmatlary: telefon aragatnaşygy, faks, printer, kseroks, skaner;",
    "• dynç alyş otagy (ýumşak we oňaýly diwanlar hem telewizor);",
    "• enäniň we çaganyň otagy;",
    "• namaz otaglary;",
    "• duş almak mümkinçilik otaglary;",
    "• bilýard otagy;",
    "• münmek üçin çykýançaň ýany bilen barmaklyk;",
    "• ähli ýüze çykýan meseleler boýunça Business Lounge wekilleriniň ýardamy (howa gatnawlarynyň uçup gitmegi barada öz wagtynda maglumatlaryň berilmegi, lukman işgäriniň çagyrylmagy we başgalar)."
]

const BusinessLounge = () => {
  return (
   <div className="w-full my-6">
   <div className='flex flex-col mx-auto w-[70%] text-lg'>
    {array.map((item) => (
      <p>{item}</p>
    ))}
    </div>
   </div>
  )
}

export default BusinessLounge